import * as React from 'react';

import { IBackendCartEntries } from '@rbi-ctg/menu';

import { EntryDescriptionRow } from './cart-entry.styled';

const resolveEntryChild = (entry: IBackendCartEntries, currencyFormatter: Function) => {
  if (!entry.children) {
    return null;
  }

  const removeDuplicates = (arr: IBackendCartEntries[]) =>
    arr.filter((value, index) => {
      const _value = JSON.stringify(value);
      return (
        index ===
        entry?.children?.findIndex(obj => {
          return JSON.stringify(obj) === _value;
        })
      );
    });

  const resolveChild = (child: IBackendCartEntries, i: number): React.ReactNode => {
    return removeDuplicates(child.children || []).length ? (
      removeDuplicates(child.children || []).map(resolveChild)
    ) : (
      <EntryDescriptionRow key={child.name! + i}>
        {child.name}
        {Boolean(child?.price) && ` - ${currencyFormatter(child.price)}`}
      </EntryDescriptionRow>
    );
  };

  return removeDuplicates(entry.children).map(resolveChild);
};

export default resolveEntryChild;
